import { subDays, compareAsc } from 'date-fns/fp';
import { isIos } from '€lib/browser/browser';
import { RootState } from '€slices/types';

const IOS_DISPLAY_AFTER_DAYS = 14;

export const getVisibilityState = (state: RootState) => {
    if (!isIos()) {
        return state.pwa.isVisible;
    }

    const { lastDisplayedTimestamp } = state.pwa;
    if (!lastDisplayedTimestamp) {
        return true;
    }

    return (
        compareAsc(subDays(IOS_DISPLAY_AFTER_DAYS, new Date()), new Date(lastDisplayedTimestamp)) <
        0
    );
};
